// /api/user

import UpdoxApi from './updoxapi';

const headers = { 'Content-Type': 'application/json' };

const getDetails = (successCallback, errorCallback) => {
  return UpdoxApi.getApi(
    '/api/user/details',
    headers,
    successCallback,
    errorCallback,
  );
};

const UserApi = {
  getDetails,
};

export default UserApi;



// WEBPACK FOOTER //
// ./src/apis/user.js